<mat-list role="list">
  <div class="mat-list-items-container">
    <table class="simple-list-table"
           border="1">
      <thead>
        <tr>
          <th>
            Existing NuageDx Medical Images (studies)
          </th>
          <th>
            Study date
          </th>
        </tr>
      </thead>
      <tbody class="table-data">
        <tr *ngFor="let study of medicalStudies">
          <td>
            {{study.fileDesc}}
          </td>
          <td>
            {{study.fdate}}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <mat-list-item *ngIf="medicalStudies?.length === 0"
                 class="item-exists"
                 role="listitem">
    No Medical Images imported yet.
  </mat-list-item>
</mat-list>
